import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

const typeLabel: Record<MovieItem['type'], string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

interface MovieCardProps {
  movie: MovieItem;
  showType?: boolean;
}

export default function MovieCard({ movie, showType = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} ${movie.genres.join(' ')}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm px-2 py-1 rounded-md">
          <i className="ri-star-fill text-accent-400 text-xs"></i>
          <span className="text-xs text-background-50 font-medium">{movie.rating.toFixed(1)}</span>
        </div>
        {showType && (
          <span className="absolute top-2 right-2 bg-primary-600 text-background-50 text-[11px] px-2 py-1 rounded-md">
            {typeLabel[movie.type]}
          </span>
        )}
        {movie.updatedEpisode && (
          <span className="absolute bottom-2 right-2 bg-accent-500 text-background-50 text-[11px] px-2 py-1 rounded-md whitespace-nowrap">
            {movie.updatedEpisode}
          </span>
        )}
      </div>
      <h3 className="mt-2 text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
        {movie.title}
      </h3>
      <p className="mt-0.5 text-xs text-foreground-500">{movie.year} · {movie.region}</p>
    </Link>
  );
}